<script setup lang="ts">
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from 'pejer/src/components/ui/form'
import { Input } from 'pejer/src/components/ui/input'

const props = defineProps<{
  addressName: string
  postalCodeName: string
  cityName: string
  forceDisplayState?: 'display' | 'input'
  ignoreValidationOnMount?: boolean
}>()
</script>

<template>
  <div class="grid grid-cols-2 md:grid-cols-4 gap-2">
    <div class="grid gap-2 col-span-2">
      <FormField
        v-slot="{ componentField }"
        :name="addressName"
        :validate-on-mount="!ignoreValidationOnMount"
      >
        <FormItem>
          <FormLabel class="text-secondaryBlack">Gateadresse</FormLabel>
          <FormControl :force-display-state="forceDisplayState">
            <Input type="text" placeholder="Trondheimsveien 184" v-bind="componentField" />
          </FormControl>
          <FormMessage />
        </FormItem>
      </FormField>
    </div>
    <div class="grid gap-2 col-span-1">
      <FormField
        v-slot="{ componentField }"
        :name="postalCodeName"
        :validate-on-mount="!ignoreValidationOnMount"
      >
        <FormItem>
          <FormLabel class="text-secondaryBlack">Postnummer</FormLabel>
          <FormControl :force-display-state="forceDisplayState">
            <Input type="text" placeholder="0571" v-bind="componentField" />
          </FormControl>
          <FormMessage />
        </FormItem>
      </FormField>
    </div>
    <div class="grid gap-2 col-span-1">
      <FormField
        v-slot="{ componentField }"
        :name="cityName"
        :validate-on-mount="!ignoreValidationOnMount"
      >
        <FormItem>
          <FormLabel class="text-secondaryBlack">Poststed</FormLabel>
          <FormControl :force-display-state="forceDisplayState">
            <Input type="text" placeholder="Oslo" v-bind="componentField" />
          </FormControl>
          <FormMessage />
        </FormItem>
      </FormField>
    </div>
  </div>
</template>

<style scoped>
input::placeholder {
  @apply text-gray-200;
}
</style>
